import React from "react";
import classes from "./Heading.module.css";

const Heading = () => {
  return (
    <div className={classes.heading}>
      <h1>E-Commerce Price Comparison Engine</h1>
    </div>
  );
};

export default Heading;
